import React from "react";
import "./buttonSelectScoringStatus.css";

const ButtonSelectScoringStatus = ({
  options,
  field,
  form: { setFieldValue },
}) => {
  const value = getValue(options, field);
  const handleChange = (option) => {
    if (!option) {
      return setFieldValue(field.name, null);
    }
    const newValue = Array.isArray(option.value)
      ? option.map((item) => item.value)
      : option.value;

    return setFieldValue(field.name, newValue);
  };
  const getClassName = (option) => {
    const base =
      "d-flex justify-content-around selectable-button-scoring-status align-items-center ";
    if (!value.length) {
      return base;
    }

    if (option.value === value[0].value) {
      return base + "active-selectable-button";
    }
    return base;
  };

  return (
    <div className="button-select-scoring-status-box">
      <div style={{ fontSize: 14, paddingTop: 15 }}>Scoring status:</div>
      <div className="button-select-scoring-status-inner-box">
        {options.map((option, i) => {
          return (
            <div
              key={`${i}-${option.value}`}
              className={getClassName(option)}
              color="primary"
              outline
              onClick={() => handleChange(option)}
            >
              {option.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

function getValue(options, field) {
  if (!options) {
    return "";
  }

  return options.filter((option) =>
    Array.isArray(field.value)
      ? field.value.indexOf(option.value) >= 0
      : field.value === option.value
  );
}

export default ButtonSelectScoringStatus;



// WEBPACK FOOTER //
// ./src/components/formik/multiple-clients/ButtonSelectScoringStatus.jsx